import {handleTryPremiumContentClick} from './module_common';

import {
    attachUpdateBookCardFavourite,
    attachUpdateBookCardMobileFavourite,
    addClass,
    removeClass,
} from './module_toggle_favourite';

import {
    configPlayerCard,
    attachBookCardPlayerBtn,
} from './module_player-card';

import { lockSelector } from './module_common_selector';

import { openModalWithRef } from './module_modal';

import { openSignInModal } from './module_auth_helper';

const mobileActionsSelector = '.mobile-actions-attach-clk';

const attachLockClick = function(){
    $(lockSelector).on('click', function(e){
        e.preventDefault();
        if (!UIDg){
            openSignInModal()
        }else{
            handleTryPremiumContentClick(window.location.href)
        }
    })
}

const attachMobileActionClick = function(){
    $(mobileActionsSelector).on('click', function(e){
        e.preventDefault();
        if (!UIDg){
            openSignInModal()
            return
        }
        const el = $(e.currentTarget)
        
        const modalSelector = '#mobile-card-actions-mod'
        const modalEl = $(modalSelector)
        const titleEl = modalEl.find(".card-action-title")
        titleEl.text(el.data('title'))

        const authorEl = modalEl.find(".card-action-author")
        authorEl.text(el.data('author'))

        const img = el.data('img')
        const imageElSelector = ".card-action-img"
        const altCoverElSelector = ".alt-cover-ref"
        if (img){
            const imgEl = modalEl.find(imageElSelector)
            imgEl.attr('src', el.data('img'))
            modalEl.find(altCoverElSelector).css("display", 'none')
            modalEl.find(imageElSelector).css("display", 'block')
        }else{
            // clear previous color class 
            modalEl.find(".alt-cover-title-ref").attr("class", "alt-cover-title-ref alt-cover-title")
            modalEl.find(".alt-cover-title-ref").addClass(el.data('altcardcolor'))
            modalEl.find(".alt-cover-title-par-ref").text(el.data('title'))
            modalEl.find(".alt-cover-author-par-ref").text(el.data('author'))
            modalEl.find(imageElSelector).css("display", 'none')
            modalEl.find(altCoverElSelector).css("display", 'flex')
        }

        const status = el.data('status')
        const elementId = el.data('elid')
        const addFavEl = modalEl.find(".add-to-fav-mobile")
        addFavEl.data('elementid', elementId)
        if (status == 0){
            addFavEl.removeClass(removeClass)
            addFavEl.addClass(addClass)
        }else{
            addFavEl.addClass(removeClass)
            addFavEl.removeClass(addClass)
        }
        
        openModalWithRef(modalSelector, el[0], "attachMobileActionClick")
    })
}

export const configBookCard = function(){
    attachLockClick()
    attachMobileActionClick()
    attachUpdateBookCardFavourite()
    attachUpdateBookCardMobileFavourite()

    configPlayerCard()
    attachBookCardPlayerBtn()
}